import { useEffect, useRef, type ReactNode } from 'react';
import { Dialog } from './controls';

export function MembershipDetailsDialog({ title, planName, address, onClose, onOpenCustomer, children }: { title: string; planName: string; address: string; onOpenCustomer?:()=>void; onClose: () => void; children: ReactNode }) {
 const content = useRef<HTMLDivElement>(null);
 useEffect(() => {
  const previous = document.activeElement as HTMLElement | null;
  const dialog = content.current?.closest<HTMLElement>('[role="dialog"]');
  const overflow = document.body.style.overflow;
  document.body.style.overflow = 'hidden';
  dialog?.querySelector<HTMLElement>('button')?.focus();
  const trap = (event: KeyboardEvent) => {
   if (event.key !== 'Tab' || !dialog) return;
   const items = [...dialog.querySelectorAll<HTMLElement>('button:not(:disabled), input:not(:disabled), select:not(:disabled), textarea:not(:disabled), a[href], [tabindex="0"]')];
   const first = items[0], last = items.at(-1);
   if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
   else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
  };
  document.addEventListener('keydown', trap);
  return () => { document.body.style.overflow = overflow; document.removeEventListener('keydown', trap); if(previous?.isConnected) previous.focus(); };
 }, []);
 return <Dialog title={title} onClose={onClose} width="max-w-2xl" className="[&>.dialog-body]:py-3" header={<header className="shrink-0 border-b border-[var(--line)]">
  <div className="flex w-full items-center justify-between gap-3 bg-[var(--brand-navy)] px-5 py-2 text-white sm:px-6">
   <p className="text-[11px] font-semibold uppercase leading-snug tracking-[.1em]">{planName}</p>
   <button type="button" aria-label="Close membership" onClick={onClose} className="grid h-8 w-8 shrink-0 place-items-center rounded-full text-xl text-white hover:bg-white/15">×</button>
  </div>
  <div className="space-y-1 px-5 py-3 sm:px-6">
   <h2 className="text-xl font-semibold leading-tight tracking-tight text-[var(--ink)]">{onOpenCustomer?<button type="button" onClick={onOpenCustomer} className="text-left text-[var(--brand-navy)] underline-offset-4 hover:underline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--brand-navy)]">{title}</button>:title}</h2>
   <p className="text-sm leading-snug text-[var(--ink-soft)]">{address}</p>
  </div>
 </header>}><div ref={content} className="space-y-3">{children}</div></Dialog>;
}
